export const DownSvg = (props: any) => {
  return (
    <svg
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.18228 6.5L6.51561 1.16666L11.8489 6.5"
        stroke={props.stroke || '#3E4685'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
